module.exports = __webpack_public_path__ + "static/media/Component 28 – 1 default.53c27eda.svg";